module.exports = __webpack_public_path__ + "img/BF.c07fc50c.svg";